/**
 * 空函数，返回 `undefined`。
 *
 * @alias module:Util.noop
 * @since 1.0.0
 * @example
 *
 * noop(); // undefined
 *
 */
function noop() {}

export default noop;
